// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"be6e3862","498":"5df59f67","703":"b8551ab3"}[chunkId] + ".chunk.js";
};